import type { ComponentStyleConfig } from "@chakra-ui/theme";
import type { StyleFunctionProps } from "@chakra-ui/theme-tools";
import { generateStripe, mode } from "@chakra-ui/theme-tools";
import { toCssVar } from "theme/utils";

const filledStyle = (props: StyleFunctionProps) => {
  const { isIndeterminate, hasStripe, color: filledTrackColor } = props;

  const stripeStyle = mode(
    generateStripe(),
    generateStripe(
      "1rem",
      "color-mix(in srgb, var(--chakra-colors-neutral-solid) 10%, transparent)",
    ),
  )(props);

  const gradient = `linear-gradient(
    to right,
    transparent 0%,
    ${toCssVar(filledTrackColor)} 50%,
    transparent 100%
  )`;

  const addStripe = !isIndeterminate && hasStripe;

  return {
    ...(addStripe && stripeStyle),
    ...(isIndeterminate
      ? { bgImage: gradient }
      : { bgColor: filledTrackColor }),
  };
};

export const Progress: ComponentStyleConfig = {
  baseStyle: (props) => ({
    filledTrack: {
      transitionProperty: "common",
      transitionDuration: "slow",
      ...filledStyle(props),
    },
  }),
};
